import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { status } from 'constants/general';
import EntitiesPriceListModal from 'modules/modals/EntitiesPriceListModal';
import { CategoryEnum } from 'constants/categories';
import SearchBar from 'modules/common/components/SearchBar/SearchBar';

import categoriesStrings from 'modules/categories/strings';

import initialIcon from 'assets/images/empty-price-lists.svg';

import Table from 'modules/common/components/Table';
import { TableItemType } from 'modules/common/components/Table/enums';
import { Container, Center, Img, Text, Button, Wrapper } from './ScansPriceListsComponent.style';

const ScansPriceListsComponent = ({
  isCreatePriceListModalHidden,
  setIsCreatePriceListModalHidden,
  searchQuery,
  handleSearchBarInputChange,
  handleShowMoreClick,
  handlePriceListEdit,
  handlePriceListDeactivate,
  healthPlanId,
  selectedPriceListInfo,
  flushPriceListInfo,
}) => {
  const [priceListsData, setPriceListsData] = useState([]);
  const [priceListsRecords, setPriceListsRecords] = useState([]);

  const priceLists = useSelector(state => state.categories.priceLists);

  const getMainRowItems = () => {
    const rows = [];
    priceLists.data?.forEach(item => {
      const { id, name, active } = item;
      rows.push({
        id,
        rowData: item,
        rowContent: [
          {
            itemContent: name,
            itemType: TableItemType.Link,
            itemPath: `${item.id}`,
            isItemClickable: false,
          },
          {
            itemContent: active,
            itemType: TableItemType.Status,
            isItemClickable: false,
          },
        ],
        editButtons: [
          {
            btnId: 1,
            btnIcon: '"\\e90a"',
            btnLabel: 'Edit',
            btnFn: () => handlePriceListEdit(item),
          },
        ],
      });
    });

    return rows;
  };

  useEffect(() => {
    setPriceListsData(priceLists.data);
  }, [priceLists.data]);

  useEffect(() => {
    setPriceListsRecords(() => getMainRowItems());
  }, [priceListsData]);

  return (
    <Container>
      {priceLists.status === status.SUCCESS && priceLists.data.length === 0 && !searchQuery ? (
        <Center>
          <Img src={initialIcon} />
          <Text>{categoriesStrings.priceLists.emptyState}</Text>
          <Button onClick={() => setIsCreatePriceListModalHidden(false)}>
            {categoriesStrings.priceLists.createAPriceList}
          </Button>
        </Center>
      ) : (
        <Wrapper>
          <Button
            style={{ marginLeft: 'auto' }}
            onClick={() => setIsCreatePriceListModalHidden(false)}
          >
            {categoriesStrings.priceLists.createPriceList}
          </Button>
          <SearchBar
            searchQuery={searchQuery}
            handleSearchBarInputChange={handleSearchBarInputChange}
            testId="healthplansearch"
          />
          <Table
            latestDataLength={priceLists.latestDataLength}
            dataStatus={priceLists.status}
            columns={categoriesStrings.labsPriceListsTable.gridHeaderList}
            rows={priceListsRecords}
            searchQuery={searchQuery}
            handleEditButton={handlePriceListEdit}
            handleDeactivate={handlePriceListDeactivate}
            handleShowMoreClick={handleShowMoreClick}
          />
        </Wrapper>
      )}

      {!isCreatePriceListModalHidden && (
        <EntitiesPriceListModal
          onClose={() => {
            flushPriceListInfo();
            setIsCreatePriceListModalHidden(true);
          }}
          healthPlanId={healthPlanId}
          priceListRecordInfo={selectedPriceListInfo}
          categoryId={CategoryEnum.Scans}
        />
      )}
    </Container>
  );
};

ScansPriceListsComponent.propTypes = {
  isCreatePriceListModalHidden: PropTypes.bool.isRequired,
  setIsCreatePriceListModalHidden: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  priceListsQueryString: PropTypes.shape({
    healthPlanId: PropTypes.number,
    categoryId: PropTypes.number,
    pageNumber: PropTypes.number,
    pagesize: PropTypes.number,
    active: PropTypes.bool,
  }).isRequired,
  handlePriceListEdit: PropTypes.func.isRequired,
  flushPriceListInfo: PropTypes.func.isRequired,
};

export default ScansPriceListsComponent;
